class LogoHover {
    private svg: SVGSVGElement;
    private paths: NodeListOf<SVGPathElement>;
    private mouseX: number = 0;
    private mouseY: number = 0;
    private torchRadius: number = 12; // Radius of the "torch" effect in pixels
    private isHovering: boolean = false;
    private originalColors: Map<SVGPathElement, string> = new Map();

    constructor(element: SVGSVGElement) {
        this.svg = element;
        this.paths = this.svg.querySelectorAll('path');

        if (this.paths.length === 0) {
            console.warn('No paths found in SVG');
            return;
        }

        // Store original fill colors
        this.paths.forEach((path) => {
            const fill = window.getComputedStyle(path).fill;
            this.originalColors.set(path, fill);
        });

        this.init();
    }

    private init() {
        // Track mouse movement on the SVG container
        this.svg.addEventListener('mouseenter', () => {
            this.isHovering = true;
        });

        this.svg.addEventListener('mouseleave', () => {
            this.isHovering = false;
            this.resetAllPaths();
        });

        this.svg.addEventListener('mousemove', (e) => {
            if (this.isHovering) {
                this.handleMouseMove(e);
            }
        });
    }

    private handleMouseMove(e: MouseEvent) {
        const svgRect = this.svg.getBoundingClientRect();
        this.mouseX = e.clientX - svgRect.left;
        this.mouseY = e.clientY - svgRect.top;

        this.updatePathColors();
    }

    private updatePathColors() {
        const svgRect = this.svg.getBoundingClientRect();
        const viewBox = this.svg.viewBox.baseVal;

        // Calculate scale factors between viewBox and rendered size
        const scaleX = viewBox.width / svgRect.width;
        const scaleY = viewBox.height / svgRect.height;

        // Convert mouse position to SVG coordinates
        const svgMouseX = this.mouseX * scaleX;
        const svgMouseY = this.mouseY * scaleY;

        this.paths.forEach((path) => {
            const bbox = path.getBBox();
            const pathCenterX = bbox.x + bbox.width / 2;
            const pathCenterY = bbox.y + bbox.height / 2;

            // Calculate distance from mouse to path center in SVG coordinates
            const distance = Math.sqrt(
                Math.pow(svgMouseX - pathCenterX, 2) +
                Math.pow(svgMouseY - pathCenterY, 2)
            );

            // Scale the torch radius to SVG coordinates
            const scaledRadius = this.torchRadius * scaleX;

            // Get original color
            const originalColor = this.originalColors.get(path) || 'rgb(0, 0, 0)';

            // Sharp transition - either black or original color, no gradient
            if (distance < scaledRadius) {
                // Inside torch radius - turn black
                path.style.fill = `rgb(0, 0, 0)`;
                path.style.transition = 'fill 0.15s ease-out';
            } else {
                // Outside torch radius - show original color
                path.style.fill = originalColor;
                path.style.transition = 'fill 0.15s ease-out';
            }
        });
    }

    private resetAllPaths() {
        this.paths.forEach((path) => {
            const originalColor = this.originalColors.get(path) || 'rgb(0, 0, 0)';
            path.style.fill = originalColor;
            path.style.transition = 'fill 0.3s ease-out';
        });
    }

    public destroy() {
        this.resetAllPaths();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    // Find the SVG in the header
    const headerSvg = document.querySelector("header svg") as SVGSVGElement;
    if (headerSvg) {
        new LogoHover(headerSvg);
    }
});

export default LogoHover;
